import * as types from './actionTypes';
import { getRequest, putRequest, postRequest, deleteRequest } from '../../lib/apiUtils';

export function getAllReferences() {
    return async dispatch => {
        dispatch({ type: types.START_GET_REFERENCES });

        const response = await getRequest("/references", null, []);

        dispatch({ type: types.GET_REFERENCES, response });
    }
}

export function updateReferencesSearch(keyword) {
    return dispatch => {
        dispatch({ type: types.UPDATE_REFERENCES_SEARCH, keyword });
    }
}

export function updateTable(settings) {
    return dispatch => {
        dispatch({ type: types.UPDATE_REFERENCES_TABLE, settings });
    }
}

export function getReferences(page = 1, results = 12, sort = { by: 'name', direction: 'Ascending' }) {
    return async (dispatch, getState) => {
        const settings = { page, results, sort };
        dispatch({ type: types.UPDATE_REFERENCES_TABLE, settings });

        const requestId = ++getState().referencesTable.currentRequestId;
        dispatch({ type: types.START_GET_REFERENCES_TABLE_RECORDS, requestId });

        const tableSettings = getState().referencesTable;
        const keyword = getState().references.keyword;
        let params = {
            page: tableSettings.page,
            sortBy: tableSettings.sort.by,
            sortDirection: tableSettings.sort.direction,
            results: tableSettings.resultsView,
            keyword
        };

        const response = await getRequest('/references', params);

        dispatch({ type: types.GET_REFERENCES_TABLE_RECORDS, ...{ response, requestId } });
    };
}

export function deleteReference(referenceId) {
    return async dispatch => {
        dispatch({ type: types.START_REMOVE_REFERENCES_TABLE_RECORD });

        const response = await deleteRequest(`/references/${referenceId}`);
        response.recordIdKey = 'referenceId';
        response.recordId = referenceId;

        dispatch({ type: types.REMOVE_REFERENCES_TABLE_RECORD, response });

        if (response.success)
            dispatch(getAllReferences());
    };
}

export function updateReference(referenceId, reference) {
    return async dispatch => {
        dispatch({ type: types.START_UPDATE_REFERENCE });

        const response = await putRequest(`/references/${referenceId}`, reference);

        dispatch({ type: types.UPDATE_REFERENCE, response });

        if (response.success)
            dispatch(getAllReferences());
    }
}

export function createReference(reference) {
    return async dispatch => {
        dispatch({ type: types.START_CREATE_REFERENCE });

        const response = await postRequest('/references', reference);

        dispatch({ type: types.CREATE_REFERENCE, response });

        if (response.success)
            dispatch(getAllReferences());
    }
}


// WEBPACK FOOTER //
// ./src/redux/actions/ReferencesActions.js